export default defineNuxtPlugin(() => {
  onNuxtReady(() => {
    const rootStore = useBrickRootStore()
    const socket = useSocket()

    let sendTime = 0

    useSocket('server_pong', (data) => {
      if (sendTime && data) {
        const endTime = Date.now()
        const serverClientTime = data.server_time + (endTime - sendTime) / 2
        const difference = endTime - serverClientTime

        const storeDifference = Math.abs(difference - (rootStore.serverTimeDifference || 0))
        if (storeDifference > 1000) {
          rootStore.setServerTimeDifference(difference)
        }
        sendTime = 0
      }
    })

    let previousTime = Date.now()
    setInterval(() => {
      const now = Date.now()
      const difference = Math.abs(now - previousTime)
      if (difference > 10000) {
        sendTime = now
        socket.emit?.('server_ping', now)
      }
      previousTime = now
    }, 5000)
  })
})
